import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { validationForSupabaseFields, extractFieldSupaBase } from './validationUtils';
import CustomLoader from '../common/CustomLoader';
import { SUPABASE } from 'drapcode-constant';
import FormFieldWithLabel from '../common/FormFieldWithLabel';
import ParentCardNoHeader from '../common/ParentCardNoHeader';
import { checkDataSourcePermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
export class SupabaseDataList extends Component {
  static propTypes = {
    dataConnector: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    developerKey: '',
    secretKey: '',
    tokenError: '',
    CustomName: '',
    nameError: '',
    dataBaseUrl: '',
  };

  handleSupabaseForm = async (values) => {
    const { developerKey, dataBaseUrl, CustomName, secretKey } = values;
    const { projectId, version } = this.props.match.params;
    const { actions, history } = this.props;

    try {
      if (!developerKey || !dataBaseUrl || !secretKey) {
        this.setState({ tokenError: 'All fields are required' });
        return;
      }
      const cleanDataBaseUrl = dataBaseUrl.replace(/\/$/, '');
      await actions.getSupabaseData({
        developerKey,
        dataBaseUrl: `${cleanDataBaseUrl}/rest/v1/`,
        projectId,
        version,
      });
      const formatedData = extractFieldSupaBase(this.props.dataConnector.supabaseData);
      if (this.props.dataConnector.supabaseData) {
        const tablesarr = formatedData.map(({ name, fields }) => ({ name, fields }));
        const dataForSave = {
          name: CustomName,
          projectId,
          type: SUPABASE,
          setting: {
            supabase_key: developerKey,
            supabaseSecret_key: secretKey,
            dataBaseUrl: `${cleanDataBaseUrl}/rest/v1/`,
          },
          completeData: {
            database: `${cleanDataBaseUrl}/rest/v1/`,
            tables: tablesarr,
          },
          projectVersion: version,
        };
        await actions.saveSupabaseDataInExternalDb({ dataForSave, projectId, version });
        const { uuid } = this.props.dataConnector.supabaseExternalData;
        await actions.supabaseEnvironmentVariables({
          dataForSave,
          projectId,
          version,
          externalDatabaseId: uuid,
        });

        // const { uuid } = this.props.dataConnector.supabaseExternalData;
        if (this.props.dataConnector.supabaseData && formatedData) {
          history.push(
            `/data-connector/${version}/v/${projectId}/supabase-collectionlist/${uuid}`,
            {
              supabaseExternalData: this.props.dataConnector.supabaseExternalData,
              token: developerKey,
              CustomName,
            },
          );
        }
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  handleCancel = () => {
    const { match, history } = this.props;
    const { projectId, version } = match.params;
    history.push(`/collections/${version}/v/${projectId}/create`);
  };

  render() {
    const isAllowed = checkDataSourcePermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Data Source" />
        </CommonPageComponent>
      );
    }
    const { getSupabaseDataPending, supabaseEnvironmentVariablesPending } =
      this.props.dataConnector;
    const { developerKey, CustomName, dataBaseUrl, secretKey } = this.state;

    return (
      <CommonPageComponent>
        <ParentContentCard title="Create Collection via Supabase" datasourceIconSvg="Supabase">
          <Formik
            initialValues={{
              developerKey,
              secretKey,
              CustomName,
              dataBaseUrl,
            }}
            validationSchema={validationForSupabaseFields({ CustomName })}
            onSubmit={this.handleSupabaseForm}
          >
            {({ isSubmitting }) => (
              <Form>
                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="Name"
                    icon="text"
                    infoIcon={true}
                    infoDescription={'Enter name for the Data Source you want to create.'}
                  >
                    <Field
                      type="text"
                      name="CustomName"
                      className="form-control form-control-sm"
                      placeholder="Data Source Name"
                    />
                    <ErrorMessage name="CustomName" component="p" className="text-danger" />
                  </FormFieldWithLabel>
                </div>
                <ParentCardNoHeader title="Supabase Account Details">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Anon Key (Public)"
                      icon="text"
                      infoIcon={true}
                      infoDescription={
                        'Enter Supabase anon public key from your Supabase account API section. This key is safe to use in a browser if you have enabled Row Level Security for your tables and configured policies.'
                      }
                    >
                      <Field
                        type="text"
                        name="developerKey"
                        className="form-control form-control-sm"
                        placeholder="Anon Key (Public)"
                      />
                      <ErrorMessage name="developerKey" component="p" className="text-danger" />
                    </FormFieldWithLabel>
                  </div>

                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Secret Key"
                      icon="text"
                      infoIcon={true}
                      infoDescription={
                        'Enter Supabase service_role secret Key from your Supabase account API section. This key has the ability to bypass Row Level Security. Never share it publicly.'
                      }
                    >
                      <Field
                        type="text"
                        name="secretKey"
                        className="form-control form-control-sm"
                        placeholder="Secret Key"
                      />
                      <ErrorMessage name="secretKey" component="p" className="text-danger" />
                    </FormFieldWithLabel>
                  </div>

                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Project Url"
                      icon="text"
                      infoIcon={true}
                      infoDescription={`Enter Project Url from your Supabase account API section. It's a RESTful endpoint for querying and managing your database.`}
                    >
                      <Field
                        type="text"
                        name="dataBaseUrl"
                        className="form-control form-control-sm"
                        placeholder="Project Url"
                      />
                      <ErrorMessage name="dataBaseUrl" component="p" className="text-danger" />
                    </FormFieldWithLabel>
                  </div>
                </ParentCardNoHeader>

                <div className="clearfix">
                  <button
                    className="btn btn-outline-secondary"
                    title="Cancel"
                    type="button"
                    onClick={this.handleCancel}
                  >
                    <i className="wb webconnect-times"></i> Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-theme-submit float-right"
                    disabled={
                      isSubmitting || getSupabaseDataPending || supabaseEnvironmentVariablesPending
                    }
                  >
                    <i className="wb webconnect-rocket"></i> &nbsp;Continue&nbsp;
                    <CustomLoader
                      loading={getSupabaseDataPending || supabaseEnvironmentVariablesPending}
                    ></CustomLoader>
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </ParentContentCard>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    dataConnector: state.dataConnector,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SupabaseDataList);
